"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./AffiliateComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var affiliateClasses = (0, _cssClassesHelper.getBEMClasses)('affiliate');
var AffiliateCountComponent = function AffiliateCountComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var affiliate = props.affiliate;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses('container-content')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: affiliateClasses('tag')
  }, affiliate.affiliateCount, " ", t("Affiliates")));
};
AffiliateCountComponent.propTypes = {
  affiliate: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = AffiliateCountComponent;